module.exports = __webpack_public_path__ + "img/email.2797b5a4.svg";